import styled, { keyframes } from 'styled-components'

const enterCard = keyframes`
    from {
        opacity: 0;
        transform: translate(-100px,0);    
    }
    to {
        opacity: 1;
        transform: translate(0, 0px);    
    }
`

export const Container = styled.div`
  width: 100%;
  flex: 1;
  display: grid;
  height: 50px;
  background: #fefefe;
  border: 1px solid #d9d8d8;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.07);
  border-radius: 5px;
  padding: 15px 10px;
  gap: 3px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  grid-template-areas:
    'a b c d'
    'a e e d'
    'f f f d';
  grid-template-rows: 17px 20px 1fr;
  grid-template-columns: 50px 1fr 80px 30px;
  opacity: 0;
  transform: translate(0, -30px);
  animation: ${enterCard} 400ms cubic-bezier(0, 0.26, 0, 0.94)
    ${(p) => p.delay}ms forwards;
  &:hover {
    transform: rotate(0.2deg) !important;
  }
  &.optout {
    transition: all 250ms linear;
    background: rgba(255, 0, 0, 0.2);
    border: 1px solid #d73535;
  }
`

export const Avatar = styled.div`
  grid-area: a;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #d05d02;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-weight: bold;
  font-size: 25px;
  line-height: 29px;
  color: #fafafa;
`

export const Customer = styled.strong`
  grid-area: b;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 16px;
  color: #000000;
`

export const Badge = styled.span`
  grid-area: c;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  color: #f4f4f4;
  font-weight: bold;
  background: #d05d02;
  border-radius: 5px;
  width: 90px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
`
export const Pets = styled.span`
  grid-area: e;
  font-size: 12px;
  color: #000000;

  text-overflow: ellipsis;
  overflow: hidden;
  width: 220px;
  height: 1.2em;
  white-space: nowrap;
`

export const Phone = styled.div`
  grid-area: f;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 5px;
  margin: 0;
  span {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    gap: 5px;
    font-size: 15px;
    line-height: 18px;
    color: #000000;
  }
`
export const Buttons = styled.div`
  grid-area: d;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  flex-direction: column;
  gap: 20px;
  padding: 0;
  margin: 0 10px 0 0;

  button {
    cursor: pointer;
    display: flex;
    width: 25px;
    height: 25px;
    justify-content: center;
    align-items: center;
    padding: 0;
    border: none;
    background: none;
    img {
      width: 100%;
      object-fit: contain;
    }
  }
`
